@if (on === 'form') {
  <div style="height: 74px">
    <img [src]="control.value" alt=""/>
  </div>
}
